<template>
  <div v-if="userId">
    <v-btn
      v-if="isLiked === true"
      text
      :loading="loading"
      @click.prevent="clickFav"
      class="fs-xs font-weight-bold fc-gray-6"
      :height="height"
      :width="width"
      outlined
      :class="size == 'm' ? 'fs-s' : 'fs-xs '"
      :rounded="size == 'm'"
    >
      <v-icon :class="size == 'm' ? 'fs-xl' : 'fs-xs '" class="mr-1"
        >sentiment_satisfied_alt</v-icon
      >登録済み
      <template v-slot:loader>
        <v-progress-circular
          :size="size == 'm' ? 16 : 12"
          :width="1"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
    </v-btn>
    <v-btn
      v-else
      depressed
      dark
      :loading="loading"
      @click.prevent="clickFav"
      :height="height"
      :width="width"
      :color="ColorPrimary"
      class="fs-xs font-weight-bold"
      :class="size == 'm' ? 'fs-s' : 'fs-xs '"
      :rounded="size == 'm'"
    >
      <v-icon :class="size == 'm' ? 'fs-xl' : 'fs-xs '" class="mr-1"
        >sentiment_satisfied_alt</v-icon
      >お気に入り
      <template v-slot:loader>
        <v-progress-circular
          :size="size == 'm' ? 16 : 12"
          :width="1"
          indeterminate
          color="white"
        ></v-progress-circular>
      </template>
    </v-btn>
  </div>
  <div v-else>
    <v-btn
      text
      :height="height"
      :width="width"
      outlined
      disabled
      :class="size == 'm' ? 'fs-s' : 'fs-xs '"
      :rounded="size == 'm'"
    >
      <v-icon x-small :class="size == 'm' ? 'fs-xl' : 'fs-xs '" class="mr-1"
        >sentiment_satisfied_alt</v-icon
      >お気に入り
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "FavBtn",
  props: {
    creatorId: {
      mode: String,
      required: true,
    },
    size: {
      mode: String,
      default: "s",
    },
  },
  data() {
    return {
      userId: this.$store.state.userId,
      loading: false,
    };
  },
  created() {},
  computed: {
    isLiked() {
      return this.$store.state.cLikedList.includes(this.creatorId);
    },
    height() {
      if (this.size == "m") {
        return 40;
      }
      return 20;
    },
    width() {
      if (this.size == "m") {
        return 160;
      }
      return 98;
    },
  },
  methods: {
    async clickFav() {
      this.loading = true;
      try {
        if (this.isLiked) {
          //お気に入り削除
          await axios.post(
            this.serverPath +
              "/api/Tailor/deleteLikeInfo?userId=" +
              this.userId +
              "&creatorId=" +
              this.creatorId
          );
          this.$store.dispatch("updateCLiked", {
            add: true,
            creatorId: this.creatorId,
          });
          this.$emit("clickFav", false);
        } else {
          //お気に入り追加
          await axios.post(
            this.serverPath +
              "/api/Tailor/addLikeInfo?userId=" +
              this.userId +
              "&creatorId=" +
              this.creatorId
          );
          this.$store.dispatch("updateCLiked", {
            add: false,
            creatorId: this.creatorId,
          });
          this.$emit("clickFav", true);
        }
      } catch (e) {
        //登録済みの場合はstoreに追加する
        const pattern1 =
          "could not extract ResultSet; SQL [n/a]; constraint [PRIMARY];";
        if (e.response.data.errorMessage.indexOf(pattern1) === 0) {
          this.$store.dispatch("updateCLiked", {
            add: false,
            creatorId: this.creatorId,
          });
        }
      } finally {
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/import.scss";

.swHelp {
  position: relative;
  color: var(--gray-8);
  background: var(--white);
  border-top: solid 1px var(--c-border);
  border-right: solid 1px var(--c-border);
  border-bottom: solid 1px var(--c-border);
  border-left: solid 4px var(--c-secondary);
  @include textBox;
}
</style>
